const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClase43(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 103.725,
    height: 103.725,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0 0 41.52 41.28L82.98 0l-41.7-41.7L0 0",
    style: {
      fill: "#0093dd",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 0 51.6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.62782 721.05623h20.1v-2.1h-20.1v2.1z",
    style: {
      fill: "#1f1a17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(-461.42782 -676.05622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.72782 721.05623h-20.1v-2.1h20.1v2.1z",
    style: {
      fill: "none",
      stroke: "#1f1a17",
      strokeWidth: 0.29999998,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-461.42782 -676.05622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .72.24.48.72.72 1.44.24 1.68v.72l.72-1.92.48-1.92-.24-1.92-.72-1.68 1.44.72.72.96.72 1.44c1.207-3.593.88-4.381-1.2-7.44l1.68.48.96.72.24.72v.48l-.24-3.36-.72-2.4-1.2-1.92-1.44-.96-1.44-.72-1.44-.24h-1.2l.48.24 1.2.72L2.4-12l1.2 2.16-1.2-.48-1.2-.24H.24l.72.48.72.96.48 1.44v2.16l-.48-1.2-.72-.72-1.68-.96.24 2.64-.48 2.16-.96 1.44-.96.96.24-1.2-.72-2.16L-4.08-6v-.96l.24-1.44-.96.48-.48.48-.48.72-.72 1.2v-2.16l.24-1.2.72-.72.72-.96-1.2.24h-.72l-.48.24-.96.72.72-2.4L-6-13.2l1.44-.72 1.68-.24-3.6.24-2.4.72-1.68 1.44-.96 1.44-.96 3.6-.72 3.12.96-.72.72-.96.96-.72 1.68-.24-.96 1.44-.48 1.2-.24 1.92.24 1.44-.24 1.92 1.2-1.92.72-.72 1.2-.72-.48 1.44v1.2l.24 1.92.24 1.2-.48 1.2.96-.24.72-.48.48-1.2.24-1.44.72-1.44c2.113 3.536-.076 6.256 1.68 10.08l.72-2.4L0 2.88l.24-1.44L0 0",
    style: {
      fill: "#1f1a17",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 56.4 23.1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .72.24.48.72.72 1.44.24 1.68v.72l.72-1.92.48-1.92-.24-1.92-.72-1.68 1.44.72.72.96.72 1.44c1.207-3.593.88-4.381-1.2-7.44l1.68.48.96.72.24.72v.48l-.24-3.36-.72-2.4-1.2-1.92-1.44-.96-1.44-.72-1.44-.24h-1.2l.48.24 1.2.72L2.4-12l1.2 2.16-1.2-.48-1.2-.24H.24l.72.48.72.96.48 1.44v2.16l-.48-1.2-.72-.72-1.68-.96.24 2.64-.48 2.16-.96 1.44-.96.96.24-1.2-.72-2.16L-4.08-6v-.96l.24-1.44-.96.48-.48.48-.48.72-.72 1.2v-2.16l.24-1.2.72-.72.72-.96-1.2.24h-.72l-.48.24-.96.72.72-2.4L-6-13.2l1.44-.72 1.68-.24-3.6.24-2.4.72-1.68 1.44-.96 1.44-.96 3.6-.72 3.12.96-.72.72-.96.96-.72 1.68-.24-.96 1.44-.48 1.2-.24 1.92.24 1.44-.24 1.92 1.2-1.92.72-.72 1.2-.72-.48 1.44v1.2l.24 1.92.24 1.2-.48 1.2.96-.24.72-.48.48-1.2.24-1.44.72-1.44c2.113 3.536-.076 6.256 1.68 10.08l.72-2.4L0 2.88l.24-1.44L0 0z",
    style: {
      fill: "none",
      stroke: "#1f1a17",
      strokeWidth: 0.23999999,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.25 0 0 -1.25 56.4 23.1)"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.99759 0 0 1.00242 -461.42782 -676.05622)",
    x: 510.95938,
    y: 761.81519,
    style: {
      fontSize: "14.96384525px"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontSize: "12.56115055px",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      writingMode: "lr-tb",
      fill: "#1f1a17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      fontFamily: "Arial",
      InkscapeFontSpecification: "Arial-BoldMT"
    },
    x: 510.95938,
    y: 761.81519
  }, "4")), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 36.24-36L72.18 0 36.24 36 0 0z",
    style: {
      fill: "none",
      stroke: "#1f1a17",
      strokeWidth: 0.71899998,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.25 0 0 -1.25 6.9 51.9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.62782 721.05623h20.1v-2.1h-20.1v2.1z",
    style: {
      fill: "#1f1a17",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(-461.42782 -676.05622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 .72.24.48.72.72 1.44.24 1.68v.72l.72-1.92.48-1.92-.24-1.92-.72-1.68 1.44.72.72.96.72 1.44c1.207-3.593.88-4.381-1.2-7.44l1.68.48.96.72.24.72v.48l-.24-3.36-.72-2.4-1.2-1.92-1.44-.96-1.44-.72-1.44-.24h-1.2l.48.24 1.2.72L2.4-12l1.2 2.16-1.2-.48-1.2-.24H.24l.72.48.72.96.48 1.44v2.16l-.48-1.2-.72-.72-1.68-.96.24 2.64-.48 2.16-.96 1.44-.96.96.24-1.2-.72-2.16L-4.08-6v-.96l.24-1.44-.96.48-.48.48-.48.72-.72 1.2v-2.16l.24-1.2.72-.72.72-.96-1.2.24h-.72l-.48.24-.96.72.72-2.4L-6-13.2l1.44-.72 1.68-.24-3.6.24-2.4.72-1.68 1.44-.96 1.44-.96 3.6-.72 3.12.96-.72.72-.96.96-.72 1.68-.24-.96 1.44-.48 1.2-.24 1.92.24 1.44-.24 1.92 1.2-1.92.72-.72 1.2-.72-.48 1.44v1.2l.24 1.92.24 1.2-.48 1.2.96-.24.72-.48.48-1.2.24-1.44.72-1.44c2.113 3.536-.076 6.256 1.68 10.08l.72-2.4L0 2.88l.24-1.44L0 0",
    style: {
      fill: "#1f1a17",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1.25 0 0 -1.25 56.4 23.1)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClase43);
export default __webpack_public_path__ + "static/media/clase4-3.4fe1e33eb38aeb9d396b9bf31f0ce8a7.svg";
export { ForwardRef as ReactComponent };